// SwmmFlow_Chart.js
import React, { useState, useEffect } from 'react'
import { UniversalDropDown } from '@fileops/swmm-react'
import { Grid, Button } from '@mui/material'
import { SwmmOutChartjs } from './components/Charting_Components/SwmmOutChartjs'
import { SwmmOut, outputDataUnitsWords } from '@fileops/swmm-node'
import MenuRoundedIcon from '@mui/icons-material/MenuRounded'

import 'mapbox-gl/dist/mapbox-gl.css'
import './iframe.css'

export default function SwmmFlow_Chart({model_1, out_1, targetParamString, targetTypeString, targetArray, showChartControlsString, lineSize=1}) {
  // Any of 
  /**
   * "Rainfall", "Snow Depth", "Evap", "Infiltration", "Runoff", "GW Flow", "GW Elev", "Soil Moisture"
   * "Depth", "Head", "Volume", "Lat. Flow", "Inflow", "Overflow"
   * "Flow", "Depth", "Velocity", "Volume", "Capacity"
   */
  //////////////////////////////////////
  const [units, setUnits] = useState(undefined)
  const [targetType, settargetType] = useState(targetTypeString)
  const [targetParameter, settargetParameter] = useState((targetParamString!=null&&targetTypeString!=null/*&&targetString*/)?SwmmOut[targetTypeString.slice(0, -1)+'_RESULTS'].indexOf(targetParamString):undefined)
  const [targetParameterVal, settargetParameterVal] = useState(undefined)
  const [resultArrayName, setResultArrayName] = useState(undefined)
  const [IDs, setIDs] = useState(["NODES", "LINKS", "SUBCATCHMENTS"])
  const [target, settarget] = useState(targetArray)
  const [objectIDs, setObjectIDs] = useState([])
  const [outData, setOutData] = useState({})
  const showChartControls = JSON.parse(showChartControlsString)

  /**
   * Dropdown menu data population.
   */
  useEffect(()=>{
    if(out_1 && out_1.value.byteLength > 0){
      if(targetType === 'NODES'){
        setResultArrayName('NODE_RESULTS')
        settargetParameterVal(2)
        setObjectIDs([...Array(out_1.totalNodes).keys()].map((o, i)=>out_1.nodeName(i)))
      } else if (targetType === 'LINKS'){
        setResultArrayName('LINK_RESULTS')
        settargetParameterVal(1)
        setObjectIDs([...Array(out_1.totalLinks).keys()].map((o, i)=>out_1.linkName(i)))
      } else if (targetType === 'SUBCATCHMENTS'){
        setResultArrayName('SUBCATCHMENT_RESULTS')
        settargetParameterVal(0)
        setObjectIDs([...Array(out_1.totalSubcatchments).keys()].map((o, i)=>out_1.subcatchmentName(i)))
      }
    }
  }, [out_1, targetType, targetParameter])

  /**
   * Parse the array buffer if there is data from a model run
   */
  useEffect(()=>{
    if(out_1 != null){
      if(targetParameter >= 0 ){
        let flowUnits = out_1.flowUnitCode()
        let unitSystem = 0
        if ( flowUnits <= SwmmOut.FLOW_UNIT_VALUES.indexOf("MGD")){
          unitSystem = SwmmOut.UNIT_SYSTEM.indexOf("US")
        }
        else {
          unitSystem = SwmmOut.UNIT_SYSTEM.indexOf("SI")
        }
        setUnits(outputDataUnitsWords[targetType.slice(0,9).slice(0, -1)][targetParameter][SwmmOut.UNIT_SYSTEM[unitSystem]](flowUnits))
      }
    }
  }, [out_1, targetParameter, targetType])

  useEffect(()=>{
    if(out_1 != null){
      setOutData(out_1.processOut(target, SwmmOut[targetType.slice(0,9).slice(0, -1)], targetParameter))
    } else{
      setOutData({})
    }
  }, [target, targetType, targetParameter])

  return(
      <>
        {
          model_1 &&
          <>
            {
              showChartControls &&
              <>
              <div onClick={()=>{}}>
              <div style={{padding: '1px 0px 0px 0px'}} ></div>
              <div className='chartcontrols' onClick={(event)=>{event.stopPropagation(); event.currentTarget.classList.toggle('showcontrols');}} style={{padding: '2px', backgroundColor: 'rgba(180, 180, 180, 1)', border: '0px solid rgba(150, 150, 150, 1)', borderRadius: '2px'}}>
                <MenuRoundedIcon fontSize="small" color="dark" style={{marginBottom: '-5px'}} />
              </div>
              <div className="controlcol hidecontrols" style={{marginLeft: '20px'}}>
                  {
                    out_1!=null &&
                    <UniversalDropDown 
                      IDs={IDs} 
                      selectText={"Select an object type"} 
                      value={targetType}
                      onChange={(val)=>{settarget([]); settargetType(val)}} >
                    </UniversalDropDown>
                  }
                  {
                    out_1!=null &&
                    targetType && 
                    targetType.length > 0 &&
                    resultArrayName &&
                    <UniversalDropDown 
                      IDs={SwmmOut[resultArrayName]} 
                      selectText={"Select an Output Parameter"} 
                      value={SwmmOut[resultArrayName][targetParameter]}
                      onChange={(val)=>settargetParameter(SwmmOut[resultArrayName].indexOf(val)===-1?undefined:SwmmOut[resultArrayName].indexOf(val))} >
                    </UniversalDropDown>
                  }
                  {
                    out_1!=null &&
                    targetType && 
                    targetType.length > 0 &&
                    <UniversalDropDown 
                      IDs={objectIDs} 
                      selectText={"Select object ID"} 
                      value={target[0]}
                      onChange={(val)=>settarget(val?[...new Set([...target, val])]:[])} >
                    </UniversalDropDown>}
              </div>
              </div>
              </>
            }
            {
              out_1!=null &&
              targetType && 
              target !== undefined && 
              targetParameter >= 0 &&
              resultArrayName &&
              <>
              <div className='controlcol' style={{height: '100%', padding: '0px 1.5% 0 1.5%', /*border: '1px solid rgba(150, 150, 150, 1)',*/ marginBottom: '1px'}}>
                <SwmmOutChartjs 
                  out_data={outData} 
                  outputSection={resultArrayName} 
                  targets={target} 
                  targetParameter={targetParameter} 
                  units={units}
                  titleText={`${SwmmOut[resultArrayName][targetParameter]}${(units && units.length>0)?', '+units:''}`}
                  lineSize={lineSize}
                />
              </div>
              </>
            }
            </>
        }
      </>
  )
}